// Where a sign-up came from (docs/project/analytics-spec.md, "Sign-up source"):
// the first touch of the browser tab that made the row, and how the row was made. The browser
// carries the touch to us in TOUCH_COOKIE as URL-encoded `utm_*` + `referrer` pairs
// (web/src/first-touch.ts); the server reads it at row creation (server/source.ts) and stores
// it once, as `users.source`.

export const TOUCH_COOKIE = "featurette_touch";

/** The landing URL's campaign parameters. */
export const UTM = {
  source: "utm_source",
  medium: "utm_medium",
  campaign: "utm_campaign",
  content: "utm_content",
  term: "utm_term",
} as const;
/** The cookie's key for the page the first visit came from; not a URL parameter. */
export const REFERRER = "referrer";

/** The cookie's keys (the landing URL's own parameter names, plus REFERRER) and the field each
 * becomes, in the order the admin shows them. */
export const TOUCH_FIELDS = [
  [UTM.source, "utmSource"],
  [UTM.medium, "utmMedium"],
  [UTM.campaign, "utmCampaign"],
  [UTM.content, "utmContent"],
  [UTM.term, "utmTerm"],
  [REFERRER, "referrer"],
] as const;

export interface Touch {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
  /** The external page the first visit came from. */
  referrer?: string;
}

/** How the row was made: the guest form, an account that started by claiming a guest video,
 * or any other new account. */
export type EntryPath = "guest_form" | "guest_claim" | "direct";

export interface SignupSource extends Touch {
  entry: EntryPath;
}
